<template>
  <lister v-bind="$attrs">
    <template v-slot="scope">
      <event-card-primary 
        v-if="scope.data?.featured"
        v-bind="scope.data?.featured" />

      <div 
        class="Grid Grid--md2 Grid--lg4 u-mb-40">
        <event-card  
          v-for="item in scope.data?.results"   
          :key="item.id"
          v-bind="item"/>
      </div>

      <alert v-if="!scope.data?.results?.length">
        No events found, please adjust your filters.
      </alert>
   </template>
  </lister>
</template>

<script>
import Lister from '../Lister/index.vue';
import EventCard from './EventCard.vue';
import EventCardPrimary from './EventCardPrimary.vue';
import Alert from '../UI/Alert.vue';

export default {
  components: {
    Lister,
    EventCard,
    EventCardPrimary,
    Alert
  }
}
</script>